module.exports = "<div [id]=\"loadingName\" [class]=\"class\">\n  <div class=\"ms-Spinner-label\">\n    {{processMessage | translate}}\n  </div>\n</div>"